import PlayLeftIcon from "@svg/new-design/play-left";
import { FC } from "react";

interface Props {
  degree: string;
  university: string;
  showUniversity: boolean;
  grade: string;
}
const DegreeItem: FC<Props> = ({
  degree,
  university,
  showUniversity,
  grade,
}) => {
  return (
    <>
      <div className="flex gap-x-1">
        <PlayLeftIcon className="fds-l:w-5  w-4   h-4     mt-0.5 fds-l:h-5    text-fds-icon-brand" />
        <div className="flex flex-col gap-y-1">
          <p className="fds-l:title-lg title-md-medium text-fds-primary">
            {degree} {grade}
          </p>
          {showUniversity && (
            <p className="fds-l:body-md body-sm text-fds-secondary">
              {university}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default DegreeItem;
